// two decimals, "," instead of ".", tousands separator
export const gramsToKgsDisplay = (grams) => {
  console.info(grams);
  const kgs = grams / 1000;
  const rounded = Math.round(kgs * 100) / 100;
  const formatted = (`${rounded}`).replace('.', ',');
  const numberPart = formatted.split(',')[0];
  const decimalPart = formatted.split(',')[1];

  const l = numberPart.length;
  if (l < 4) {
    return formatted;
  } else {
    const lastTree = numberPart.slice(l - 3);
    const front = numberPart.slice(0, l - 3);
    return `${front} ${lastTree}.${decimalPart ? decimalPart : '00'}${
      decimalPart && decimalPart.toString().length === 1 ? '0' : ''
    }`;
  }
};

export const everyValueInObjectIsFalse = (obj) => Object.values(obj).every((elem) => elem === false);

/**
 * gets a random short string
 * does not handle any collisions */
export const getUID = () => Math.random()
  .toString(36)
  .substring(7);

export const nonEmptyArray = (arr) => arr && Array.isArray(arr) && arr.length > 0;
export const objectHasAnyNonEmptyArrays = (obj) => Object.getOwnPropertyNames(obj).some((n) => nonEmptyArray(obj[n]));

export const mergeAndDeduplicteArrays = (a, b) => a.concat(b.filter((item) => a.indexOf(item) < 0));

export const flatArray = (arr) => arr.reduce((a, b) => a.concat(b), []);

export const inRange = (num, range) => num >= range[0] && num <= range[1];
// first letter uppercase, rest lowercase
export const capitalize = (str) => {
  if (!str) {
    return str;
  }
  if (str.length === 1) {
    return str.toUpperCase();
  }
  return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};

export const groupObjectsByKey = (objects, key) => {
  const out = {};
  objects.forEarch((o) => {
    if (!out[o.key]) {
      out[o.key] = [];
    }
    out[o.key].push(o);
  });
  return out;
};

export const arraySum = (arr) => {
  if (arr.length === 0) {
    return 0;
  }
  return arr.reduce((a, b) => a + b);
};

export const int = (str) => Number.parseInt(str, 10);
export const float = (str) => Number.parseFloat(str, 10);

export const sumArrayByFunc = (arr, sumFunc) => {
  let acc = 0; 
  arr.forEach(a => {
    acc += sumFunc(a);
  })
  return acc;
 }